export const filePDF={
    INFORMATION:{
        INSTRUCTIVO:"../assets/pdf/informationPDF/InstructivosCuPa.pdf",
        PERFIL_TRIBUTARIO:{
            URL:"../assets/pdf/informationPDF/perfilTributario/{code}.zip",  
            INFORMATION_UPDATE_LAST:'29/03/2022',
        },
        POLITICAS_AR:"../assets/pdf/informationPDF/PoliticaCUPA_AR.pdf",
        POLITICAS_MX:"../assets/pdf/informationPDF/PoliticaCUPA_MX.pdf"
    },
    
}
//ultima modificacion 29/03/2022